import {
	getSlugForProductVariant,
	getVariantStringAttribute,
} from "../../utils/storyblok/product-variant";

export interface Material {
	material?: Queries.MaterialFragment | null;
	url?: string | null;
	selected: boolean;
}
export const getMaterials = (
	product: Queries.CommerceToolsProductFragment,
	variant: Queries.ProductVariantFragment,
) => {
	const masterMaterial = {
		material: product.masterVariant?.storyblok_variant_pages?.[0]?.material,
		url: getSlugForProductVariant(product.masterVariant),
		color: getVariantStringAttribute(product.masterVariant, "color"),
		selected: isCurrentMaterial(product.masterVariant, variant),
	};
	const otherMaterials = product.variants.map((currentVariant) => ({
		material: currentVariant.storyblok_variant_pages?.[0]?.material,
		url: getSlugForProductVariant(currentVariant),
		color: getVariantStringAttribute(currentVariant, "color"),
		selected: isCurrentMaterial(currentVariant, variant),
	}));
	const materials = [masterMaterial, ...otherMaterials]
		.sort((material) =>
			material.color === getVariantStringAttribute(variant, "color") ? 0 : 1,
		)
		.reduce(
			(uniqueMaterials, currentMaterial) => {
				if (
					uniqueMaterials.some(
						(material) =>
							material.material?.slug === currentMaterial.material?.slug,
					)
				)
					return uniqueMaterials;
				return [...uniqueMaterials, currentMaterial];
			},
			[] as {
				material: Queries.MaterialFragment | undefined | null;
				url: string | null | undefined;
				selected: boolean;
			}[],
		);

	if (!materials.some((material) => material.selected)) {
		return [];
	}
	return materials;
};

const isCurrentMaterial = (
	variant: Queries.ProductVariantFragment | null,
	materialVariant: Queries.ProductVariantFragment,
) =>
	Boolean(variant?.storyblok_variant_pages?.[0]?.material) &&
	Boolean(materialVariant.storyblok_variant_pages?.[0]?.material) &&
	variant?.storyblok_variant_pages?.[0]?.material?.slug ===
		materialVariant.storyblok_variant_pages?.[0]?.material?.slug;
